// @flow
import { ChatActionTypes } from './constants';

type ChatAction = { type: string, payload: {} | string };

// common success
export const chatApiResponseSuccess = (actionType: string, data: any): ChatAction => ({
    type: ChatActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const chatApiResponseError = (actionType: string, error: string): ChatAction => ({
    type: ChatActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const listSalas = (id: string): ChatAction => ({
    type: ChatActionTypes.LIST_SALAS,
    payload: { id },
});

export const getUserChat = (id: string): ChatAction => ({
    type: ChatActionTypes.GET_USUARIO,
    payload: { id },
})

export const getAllUsersChat = (id: string): ChatAction => ({
    type: ChatActionTypes.LIST_USUARIOS,
    payload: { id },
})

export const getUsersInSala = (id: string): ChatAction => ({
    type: ChatActionTypes.LIST_USUARIOS_IN_SALA,
    payload: { id },
})

export const getAllMessages = (params: any): ChatAction => ({
    type: ChatActionTypes.LIST_MSG,
    payload: params
})

export const addMessage = (data: any): ChatAction => ({
    type: ChatActionTypes.ADD_MSG,
    payload: data
})

export const getNotifications = (id: string): ChatAction => ({
    type: ChatActionTypes.GET_NOTIFICATIONS,
    payload: { id },
})

export const updatePinned = (data: any): ChatAction => ({
    type: ChatActionTypes.UPDATE_PINNED,
    payload: data
})

export const updateNotifications = (data: any): ChatAction => ({
    type: ChatActionTypes.UPDATE_NOTIFICATIONS,
    payload: data
})

export const getMissingMessages = (data: any): ChatAction => ({
    type: ChatActionTypes.MISSING_MSG,
    payload: data
})

export const deleteMessage = (data: any): ChatAction => ({
    type: ChatActionTypes.DELETE_MSG,
    payload: data
})

// File Manager
export const createFolder = (data: any): ChatAction => ({
    type: ChatActionTypes.CREATE_FOLDER,
    payload: data
})

export const deleteFile = (data: any): ChatAction => ({
    type: ChatActionTypes.DELETE_FILE,
    payload: data
})

export const getAllFiles = (data: any): ChatAction => ({
    type: ChatActionTypes.LIST_FILES,
    payload: data
})

export const uploadFile = (data: any): ChatAction => ({
    type: ChatActionTypes.UPLOAD_FILE,
    payload: data
})

export const downloadFile = (data: any): ChatAction => ({
    type: ChatActionTypes.DOWNLOAD_FILE,
    payload: data
})

// Calendar
export const getEventosCalendario = (id: string): ChatAction => ({
    type: ChatActionTypes.LIST_EVENTOS_CALENDARIO,
    payload: { id },
});

export const addEventoCalendario = (data: any): ChatAction => ({
    type: ChatActionTypes.CREATE_EVENTO_CALENDARIO,
    payload: data,
});

export const updateEventoCalendario = (data: any): ChatAction => ({
    type: ChatActionTypes.UPDATE_EVENTO_CALENDARIO,
    payload: data,
});

export const deleteEventoCalendario = (data: any): ChatAction => ({
    type: ChatActionTypes.DELETE_EVENTO_CALENDARIO,
    payload: data,
});

// Resets
export const resetChat = (): ChatAction => ({
    type: ChatActionTypes.RESET,
    payload: {},
});

export const resetMessage = (): ChatAction => ({
    type: ChatActionTypes.RESET_MSG,
    payload: {},
});

export const resetEvents = (): ChatAction => ({
    type: ChatActionTypes.RESET_EVENTOS,
    payload: {},
});

// Filters
export const setFilterChat = (data: any): ChatAction => ({
    type: ChatActionTypes.SET_FILTER,
    payload: data
})

